<app-introtext>
  <h1>
    {{'REMINDER.header' | translate}}
  </h1>
  <p>{{'REMINDER.subheader' | translate}}</p>
</app-introtext>
<div class="container">
  <div class="default-reminder" *ngIf="defaultReminder !== null">
    <div class="default-reminder-text" translate="REMINDER.DEFAULT.info-1"></div>

    <div class="default-reminder-time-day">
      <span class="time">{{ defaultReminder.time.hours }} : {{ defaultReminder.time.minutes }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.mo">{{ "GENERAL.daysShort.1" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.di">{{ "GENERAL.daysShort.2" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.mi">{{ "GENERAL.daysShort.3" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.do">{{ "GENERAL.daysShort.4" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.fr">{{ "GENERAL.daysShort.5" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.sa">{{ "GENERAL.daysShort.6" | translate | uppercase }}</span>
      <span class="day" [class.active]="defaultReminder.repeatOnDays.so">{{ "GENERAL.daysShort.0" | translate | uppercase }}</span>
      <span class="bell"><img src="assets/icons/notification.svg" /></span>
    </div>

    <div class="default-reminder-text" translate="REMINDER.DEFAULT.info-2"></div>
    <div class="down-arrow border"></div>
    <div class="down-arrow"></div>
  </div>

  <div class="add-box-container">
    <app-reminder-box (doneEditing)="addBox($event)" [canAdd]="true" [reminder]="newNotification" #myReminder></app-reminder-box>
  </div>

  <div class="reminder-container" [@flyInOutParent]>
    <div class="box-wrapper" *ngFor="let notification of myNotifications" [@fadeIn]>
      <app-reminder-box
        (startEditing)="enterEditMode($event)"
        (doneEditing)="leaveEditMode($event)"
        (delete)="deleteBox($event)"
        [reminder]="notification" #myReminder>
      </app-reminder-box>
    </div>
  </div>

  <div class="action-row">
    <div class="pause-toggle" *ngIf="myNotifications.length > 0">
      <app-date-range-picker *ngIf="isPaused" [loadedStart]="pauseRange.beginDate" [loadedEnd]="pauseRange.endDate" (onChange)="onDateRangeChanged($event)"></app-date-range-picker>
      <mat-slide-toggle color="primary" (change)="togglePause($event)" [checked]="isPaused">{{'REMINDER.pauseToggle' | translate}}</mat-slide-toggle>
    </div>
  </div>

</div>





// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/notification/notification.component.html